import { useDataFormStore } from "@/stores/form";
import { NEWEST_BACKEND } from "@/remotes";
import { getSpecialClientIntervals, FALLBACK_INTERVAL } from "@/utils/timeIntervals";

// Необходимо указать после добавления необходимых параметров
let cargoTypes = {
    'Стандарт' : 1,
    'Цилиндры' : 2,
    'Шины' : 3,
  }

export async function refreshPackagesAPI(index = undefined) {

    const dataForm = useDataFormStore();

    if(dataForm.cargoInformation.natureOfCargo == [] || !dataForm.cargoInformation.natureOfCargo) return;
    if(!dataForm.cargoInformation.natureOfCargo.id) return

    if(dataForm.cargoInformation.natureOfCargo.id == -1) {
      dataForm.services.typeOfPackagings.value = [];
      return;
    }

    if( (dataForm.other.cargoCost == '') ||
      (dataForm.cargoInformation.cargoWeight == '') ||
      (dataForm.cargoInformation.cargoDimensions.width == '') ||
      (dataForm.cargoInformation.cargoDimensions.length == '') ||
      (dataForm.cargoInformation.cargoDimensions.height == '') ||
      (dataForm.cargoInformation.sizeOfCargoCylinder.height == '') ||
      (dataForm.cargoInformation.sizeOfCargoCylinder.diameter == '')
    ) return;

    if( (dataForm.other.cargoCost < 3000) ||
      (dataForm.cargoInformation.cargoWeight == 0) ||
      (dataForm.cargoInformation.cargoDimensions.width == 0) ||
      (dataForm.cargoInformation.cargoDimensions.length == 0) ||
      (dataForm.cargoInformation.cargoDimensions.height == 0) ||
      (dataForm.cargoInformation.sizeOfCargoCylinder.height == 0) ||
      (dataForm.cargoInformation.sizeOfCargoCylinder.diameter == 0)
    ) return;

    if(index) {
      if(dataForm.packages.additionalPackagingGroupIds.includes(index)) {
        var indexArr = dataForm.packages.additionalPackagingGroupIds.indexOf(index);
        if (indexArr !== -1) {
          dataForm.packages.additionalPackagingGroupIds.splice(indexArr, 1);
        }
      } else {
        dataForm.packages.additionalPackagingGroupIds.push(index);
      }
    } else {
      dataForm.packages.additionalPackagingGroupIds = [];
      dataForm.packages.additionalPackagingGroup = []
    }
    

    let param = new URLSearchParams();
    param.append('CargoNaturesId', dataForm.cargoInformation.natureOfCargo.id);
    param.append('CargoType', cargoTypes[dataForm.cargoInformation.typeOfCargo]);
    param.append('DeclaredValue', dataForm.other.cargoCost);
    param.append('Weight', dataForm.cargoInformation.cargoWeight);

    if(dataForm.packages.additionalPackagingGroupIds) {
      dataForm.packages.additionalPackagingGroupIds.forEach(element => {
        param.append('SelectedPackaging', element);
      });
    }

    switch (cargoTypes[dataForm.cargoInformation.typeOfCargo]) {
      case 1:
        param.append('Length', Math.round(dataForm.cargoInformation.cargoDimensions.length));
        param.append('Width', Math.round(dataForm.cargoInformation.cargoDimensions.width));
        param.append('Height', Math.round(dataForm.cargoInformation.cargoDimensions.height));
        break;
      case 2:
        param.append('Height', Math.round(dataForm.cargoInformation.cargoDimensions.height));
        param.append('Diameter', Math.round(dataForm.cargoInformation.cargoDimensions.diameter));
        break;
    }

    let config = {
      headers: {
        'Content-Type': 'application/json',
      },
      params: param,
    }

    // Запрос на упаковки
    try {
      const { data } = await NEWEST_BACKEND.get(`/public/available-packaging`, config);
      

      dataForm.services.typeOfPackagings.value = data.filter((el) => !el.title.includes('УниПАК'));

      // Собираем массив выбранных посылок
      let selectedPackages = [];
      let selectedPackagesIds = [];

      data.forEach(element => {
        // if(element.isRequired == true && requiredNeeded()) {
        //   if(!dataForm.packages.additionalPackagingGroup.includes(element.title)) {
        //     selectedPackages.unshift(element.title);
        //     selectedPackagesIds.push(element.id);
        //   }
        // }
        if(dataForm.packages.additionalPackagingGroup.includes(element.title)) {
          selectedPackages.push(element.title);
          selectedPackagesIds.push(element.id);
        }
      });
      
      dataForm.packages.additionalPackagingGroupIds = selectedPackagesIds;
      dataForm.packages.additionalPackagingGroup = selectedPackages;

      const month = new Date().getMonth();
      const isSummer = month >= 5 && month <= 7;

      dataForm.warmPlace = !isSummer && selectedPackages.includes('Термобокс');

    } catch (e) {
      console.log(e);
    }
  }

// Подсоеденен к watch
export async function refreshTimePickup(type = false) {

  const dataForm = useDataFormStore();

  if((dataForm.consignee.cityTo == '') || (dataForm.sender.cityFrom == '')) return;

  

  // Только если загружаем временные промежутки от города отправки,
  // при отстуствии даты завершаем процесс обновления списка
  if(!type) if(dataForm.applicationCargoPickup.pickupDate == '') return;
  
  // Подготавливаем параметры
  let param = new URLSearchParams();
  let date;

  let city = (type) ? dataForm.cityDataTo.value.filter(e => e.title == dataForm.consignee.cityTo)[0]['id'] : dataForm.cityDataFrom.value.filter(e => e.title == dataForm.sender.cityFrom)[0]['id']
  param.append('cityId', city);

  // Только если загружаем временные промежутки от города отправки,
  // указываем доп. данные
  if(!type) {
    date = new Date(dataForm.applicationCargoPickup.pickupDate)
    date = date.getFullYear() + '-' + ('0' + (date.getMonth()+1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)

    param.append('date', date);

    param.append('CargoType', cargoTypes[dataForm.cargoInformation.typeOfCargo]);
    param.append('Weight', dataForm.cargoInformation.cargoWeight);

    if(dataForm.packages.additionalPackagingGroupIds) {
      dataForm.packages.additionalPackagingGroupIds.forEach(element => {
        param.append('SelectedPackaging', element);
      });
    }
    

    switch (cargoTypes[dataForm.cargoInformation.typeOfCargo]) {
      case 1:
        param.append('Length', Math.round(dataForm.cargoInformation.cargoDimensions.length));
        param.append('Width', Math.round(dataForm.cargoInformation.cargoDimensions.width));
        param.append('Height', Math.round(dataForm.cargoInformation.cargoDimensions.height));
        break;
      case 2:
        param.append('Height', Math.round(dataForm.cargoInformation.cargoDimensions.height));
        param.append('Diameter', Math.round(dataForm.cargoInformation.cargoDimensions.diameter));
        break;
    }
  }
  
  

  let config = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: param,
  }

  // Запрос на упаковки
  try {
    if (type) {

      const { data } = await NEWEST_BACKEND.get(`/public/available-delivery-time`, config);

      dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value = data;

      dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value = (dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value[0])
        ? dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value
        : FALLBACK_INTERVAL;

      dataForm.applicationCargoPickupTime.cargoTimePickupDelivery = (dataForm.consignee?.cityTo.includes('(Москва)')) ? dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value[0] : [];

    } else {

      const { data } = await NEWEST_BACKEND.get(`/public/available-pick-up-time`, config);

      dataForm.applicationCargoPickupTime.cargoTimePickupRange.value = data.filter(e => {
        return e.date == date
      });

      dataForm.applicationCargoPickupTime.cargoTimePickupRange.value = (dataForm.isSpecialClient)
        ? getSpecialClientIntervals()
        : (dataForm.applicationCargoPickupTime.cargoTimePickupRange.value[0]) 
          ? dataForm.applicationCargoPickupTime.cargoTimePickupRange.value[0].pickUpTimePeriods
          : FALLBACK_INTERVAL;

      dataForm.applicationCargoPickupTime.cargoTimePickup = [];

    }

  } catch (e) {
    console.log(e);
  }
}

export async function refreshTimePickupDelivery() {
  
  refreshTimePickup('delivery');
}